import React from 'react';
import ItemHelper from "../../services/Menu/services/Item/ItemHelper";
import {RootState} from "../../../reducers";
import {getItemGroups, getItems} from "../../services/Menu/reducer";
import {getCart} from "../../services/Cart/reducer";
import {getVouchers} from "../../services/User/reducer";
import {connect} from "react-redux";
import MenuProductModal from "../../pages/Menu/components/Product/MenuProductModal";
import {getStoreConfig} from "../../services/Store/reducer";

interface OwnProps {
    itemId: number;
    show: boolean;
    onHide: () => void;
    preventRemovePromotionOnHide?: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const PromotionItemAddModal = ({
                                   items,
                                   itemId,
                                   itemGroups,
                                   show,
                                   onHide,
                                   preventRemovePromotionOnHide,
                                   config,
                                   setShow
                               }: Props) => {
    const item = ItemHelper.getItem(items, itemId);
    const itemGroup = ItemHelper.getItemGroup(itemGroups, item.id);

    if (!item) return null;

    return (
        <MenuProductModal show={show} config={config} setShow={setShow} item={item} itemGroup={itemGroup}
                          preventRemovePromotionOnHide={preventRemovePromotionOnHide} onHide={onHide}/>
    )
}

const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    itemGroups: getItemGroups(state.menu),
    cart: getCart(state.cart),
    vouchers: getVouchers(state.user),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default connector(PromotionItemAddModal);